export default function ValueProposition() {
  return (
    <section className="py-16 lg:py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
            Why Most "Cheap" Cars Are Actually Expensive
          </h2>
          <p className="text-xl text-slate-700 max-w-3xl mx-auto">
            Affordable doesn't mean unreliable. Here's what makes our sub-$10k inventory different 
            from the "buy here, pay here" lots down the street.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <div className="bg-white p-8 rounded-xl border border-slate-200">
            <div className="w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-close-circle-line text-2xl text-red-600"></i>
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">What Other Dealers Do</h3>
            <ul className="space-y-3 text-slate-700">
              <li className="flex items-start gap-3">
                <i className="ri-close-line text-red-500 mt-1 flex-shrink-0"></i>
                <span>Buy auction cars with hidden damage and hope you don't notice</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-close-line text-red-500 mt-1 flex-shrink-0"></i>
                <span>Slap on a fresh coat of paint and call it "reconditioned"</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-close-line text-red-500 mt-1 flex-shrink-0"></i>
                <span>Sell you a car with bald tires and say "it passed inspection"</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-close-line text-red-500 mt-1 flex-shrink-0"></i>
                <span>Add $2,000 in "dealer fees" at the last minute</span>
              </li>
            </ul>
          </div>

          <div className="bg-white p-8 rounded-xl border border-slate-200">
            <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-check-double-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">What We Actually Do</h3>
            <ul className="space-y-3 text-slate-700">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                <span>Source cars from local owners who kept maintenance records</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                <span>Fix what needs fixing before we list it — not after you buy it</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                <span>Show you the inspection report and let you ask questions</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                <span>Price it fairly from the start — no haggling required</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 max-w-3xl mx-auto bg-slate-900 text-white p-8 rounded-xl">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-chat-quote-line text-2xl text-white"></i>
            </div>
            <div>
              <h4 className="font-bold text-xl mb-3">The Rockhound Promise</h4>
              <p className="text-slate-200 mb-4">
                If we wouldn't sell it to our mom, we won't sell it to you. And our mom is very particular about her cars.
              </p>
              <p className="text-slate-300 text-sm">
                (She drives a 2012 Honda CR-V with 180k miles that she bought from us. It's still going strong. Hi, Mom.)
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
